import * as React from "react"

export const GoogleLogo = ({ ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_3307_664)">
        <path
          d="M23.0912 9.91355L13.3018 9.91309C12.8696 9.91309 12.5192 10.2634 12.5192 10.6957V13.823C12.5192 14.2552 12.8696 14.6056 13.3018 14.6056H18.8146C18.2109 16.1722 17.0842 17.4842 15.6468 18.3178L17.9974 22.387C21.7681 20.2062 23.9974 16.3799 23.9974 12.0965C23.9974 11.4866 23.9524 11.0506 23.8625 10.5597C23.7942 10.1867 23.4704 9.91355 23.0912 9.91355Z"
          fill="#167EE6"
        ></path>
        <path
          d="M11.9989 19.3043C9.30108 19.3043 6.94589 17.8303 5.68097 15.649L1.61194 17.9944C3.68264 21.5832 7.56174 24 11.9989 24C14.1757 24 16.2296 23.4139 17.9989 22.3925V22.387L15.6483 18.3177C14.5731 18.9414 13.3288 19.3043 11.9989 19.3043Z"
          fill="#12B347"
        ></path>
        <path
          d="M17.9987 22.3925V22.387L15.648 18.3177C14.5728 18.9413 13.3286 19.3043 11.9987 19.3043V24C14.1754 24 16.2294 23.4139 17.9987 22.3925Z"
          fill="#0F993E"
        ></path>
        <path
          d="M4.69505 11.9999C4.69505 10.6701 5.05795 9.42601 5.68144 8.35084L1.6124 6.00549C0.585421 7.76926 -0.000610352 9.8176 -0.000610352 11.9999C-0.000610352 14.1822 0.585421 16.2306 1.6124 17.9943L5.68144 15.649C5.05795 14.5738 4.69505 13.3297 4.69505 11.9999Z"
          fill="#FFD500"
        ></path>
        <path
          d="M11.9989 4.69566C13.7582 4.69566 15.3742 5.32078 16.6364 6.36061C16.9477 6.61711 17.4003 6.5986 17.6856 6.31336L19.9013 4.09758C20.225 3.77395 20.2019 3.24422 19.8562 2.94431C17.7414 1.10967 14.9899 0 11.9989 0C7.56173 0 3.68264 2.41674 1.61194 6.00558L5.68097 8.35092C6.94589 6.16969 9.30108 4.69566 11.9989 4.69566Z"
          fill="#FF4B26"
        ></path>
        <path
          d="M16.6361 6.36061C16.9475 6.61711 17.4001 6.59859 17.6853 6.31336L19.9011 4.09758C20.2247 3.77395 20.2016 3.24422 19.8559 2.94431C17.7412 1.10963 14.9896 0 11.9987 0V4.69566C13.7579 4.69566 15.3739 5.32078 16.6361 6.36061Z"
          fill="#D93F21"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_3307_664">
          <rect width="24" height="24" fill="white"></rect>
        </clipPath>
      </defs>
    </svg>
  )
}
